import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué ejercicio vas a dar hoy', 'Tus alumnas no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de las alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnas de distintos niveles juntas y la clase se convierte en un caos', 'Fin de mes y las alumnas se van sin avisar porque la comunicación es inconsistente'];
export const PainPoints = () => {
  return <section className="py-8 md:py-14 bg-red-50/30" data-id="element-185">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-187">
          <h2 className="text-2xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-188">
            Si sos instructora de Pilates en Argentina,{' '}
            <span className="text-red-800/80 italic" data-id="element-189">
              esto te va a sonar familiar:
            </span>
          </h2>
        </motion.div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl p-5 md:p-12 border border-red-100" data-id="element-190">
          <ul className="space-y-3 md:space-y-6" data-id="element-191">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-192">
                <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-193" />
                <span className="text-sm md:text-lg text-gray-700" data-id="element-194">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8
        }} className="mt-6 md:mt-12 text-center" data-id="element-195">
            <p className="text-xl md:text-3xl font-bold text-charcoal font-playfair" data-id="element-196">
              ¿Cuántas clases más vas a improvisar?
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};